import { render, staticRenderFns } from "./LISMethod.vue?vue&type=template&id=2c550526&scoped=true"
import script from "./LISMethod.vue?vue&type=script&lang=js"
export * from "./LISMethod.vue?vue&type=script&lang=js"
import style0 from "./LISMethod.vue?vue&type=style&index=0&id=2c550526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c550526",
  null
  
)

export default component.exports